import React from 'react';
import FeaturePageTemplate from '../../components/FeaturePageTemplate';

const SocialPostFeature = () => {
  return (
    <FeaturePageTemplate
      seoKey="socialPost"
      heroHeadline="Stop staring at the post composer."
      heroSubheadline="Generate a Facebook or Instagram post in your voice, in under a minute."
      ctaText="Generate My First Post"
      problemText="You know you should be posting. But every time you open the composer, the cursor blinks back and you close the tab. Another week goes by with zero presence — and the agents who post weekly are the ones getting called."
      rootCauseText="You don't have a system that turns your week into content — using your voice."
      solutionIntro="Social Post Generator writes the post for you, in your voice."
      solutionBullets={[
        "Pick a post type — listed, sold, tip, market update",
        "Writes in your saved tone, market, and humor level",
        "Caption + hashtags + image idea, ready to copy",
        "One tap to try again until it sounds like you"
      ]}
      beforeItems={["Silent", "Inconsistent", "Invisible"]}
      afterItems={["Posting", "On-brand", "Top of mind"]}
      proofText="Built for agents who'd rather close deals than write captions."
    />
  );
};

export default SocialPostFeature;
